export enum JourneyStatus {
  DRAFT = 'draft',
  RUNNING = 'running',
  FINISHED = 'finished',
  ARCHIVED = 'archived',
  PAUSED = 'pause'
}
